// 类型
export const typeList = [
    { type: '日常工作' },
    { type: '突发情况处理' },
    { type: '工作问题与建议' }
]
